import BaseModel from "@model/BaseModel";
import { observable } from "mobx";
import { Type } from "@eman/class-transformer";
import Allocation from "@model/Allocation";

export default class AllocationItemGroup extends BaseModel {
  @observable value: number;
  @Type(() => Number)
  @observable
  allocation_id: number;
  @Type(() => Date)
  @observable
  valid_from: Date;
  @Type(() => Date)
  @observable
  valid_to: Date;
  @Type(() => Allocation)
  @observable
  allocation: Allocation;
}
